module.exports = __webpack_public_path__ + "img/voided.95919683.svg";